import { FC, Fragment, createElement } from 'react';
import { embeddedBundle } from './locale/embeddedI18N';
import { BusyStateIndicator } from '@sas/nova-commons/components/BusyStateIndicator';
import { useDesignTokens } from '@sas/nova-commons/theme';

// TODO: move this into a SASReport folder
export const Loading: FC<{}> = () => {
  const dt = useDesignTokens();
  return (
    <Fragment>
      {/* Force AvenirNext to load since we probably need that in the reports. The BusyState handles AvenirNext-Bold*/}
      <span style={{ visibility: 'hidden', position: 'absolute', fontFamily: '"AvenirNext"' }}>
        {/* eslint-disable-line @sas/i18n/jsx-to-localize */}
        Mg
      </span>
      <div
        style={{
          display: 'flex',
          flexShrink: 1,
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          backgroundColor: dt.enableNovaTokens
            ? dt.backgroundsNova.panes.bg
            : dt.backgrounds.panes.bg,
        }}
      >
        <BusyStateIndicator active text={embeddedBundle['loading.msg']()} delay={0} />
      </div>
    </Fragment>
  );
};
